import { Flex, Stack, Tooltip, Text } from "@mantine/core"
import { SourceIcon } from "../../../../../../utils/SourceIcon"
import { getEvidenceDisplayTitle } from "../../../../../../utils"


const TicketTitle = ( {item, cxItem, origin, hasComments} : {item: any, cxItem: any, origin: string, hasComments?: boolean | null} ) => {
  // For conversation items (no comments), use the evidence title — falling back to the
  // first few words of the description when the title itself is blank.
  // For support tickets (has comments), use the original logic
  const descriptionFallback = getEvidenceDisplayTitle(undefined, item?.text) || undefined;
  const displayTitle = hasComments === false
    ? (item?.title || descriptionFallback)
    : (item?.textItem?.title || cxItem?.title);

  return (
    <Flex align="center" h={70} mx="sm">
      {origin && (
        <Tooltip label={origin || "N/A"}>
          <Stack h={20} w={20} ml={10} justify="center" align="center">
            <SourceIcon sourceName={origin?.toLowerCase() || "N/A"} />
          </Stack>
        </Tooltip>
      )}
      <Flex pl={12} align="center" w={600}>
        <Tooltip label={displayTitle || "N/A"}>
          <Text ml="3px" fz={17} maw={600} w={600} fw={600} lineClamp={1}>
            {displayTitle || "N/A"}
          </Text>
        </Tooltip>
      </Flex>
    </Flex>
  )
}

export default TicketTitle